import React from 'react';
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from 'react-router-dom';

import AuthenticatedRoute from './AuthenticatedRoute';
import Home from './Home';
import Error from './Error';
import OAuthCallback from './OAuthCallback';
import UserDashboard from './UserDashboard';
import ProgramSummary from './ProgramSummary';
import Educate from './Educate';
import Explore from './Explore';
import PatientDetails from './PatientDetails/index.js';
import VariantDetails from './VariantDetails';
import VariantAnnotationData from './VariantAnnotationData';
import AddInterpretation from './AddInterpretation';
import VariantConsensus from './VariantConsensus';
import ProgramDashboard from './ProgramDashboard';
import UserManagement from './UserManagement';
import ProgramSettings from './ProgramSettings';
import VariantDashboard from './VariantDashboard';
import WorkflowRuns from './WorkflowRuns/index.js';

import Landing from './Landing';
import Help from './Help';

import Paths from '../config/Paths.js';

const LoginRedirect = () => {
  window.location.href = Paths.samsAuth;
  return null;
};

const router = createBrowserRouter([
  {
    path: "/home",
    element: (
      <AuthenticatedRoute>
        <Home />
      </AuthenticatedRoute>
    ),
  },
  {
    path: "/programsummary",
    element: (
      <AuthenticatedRoute>
        <ProgramSummary />
      </AuthenticatedRoute>
    ),
  },
  {
    path: "/educate",
    element: (
      <AuthenticatedRoute>
        <Educate />
      </AuthenticatedRoute>
    ),
  },
  {
    path: "/explore",
    element: (
      <AuthenticatedRoute>
        <Explore />
      </AuthenticatedRoute>
    ),
  },
  {
    path: "/patientdetails/:patientId",
    element: (
      <AuthenticatedRoute>
        <PatientDetails />
      </AuthenticatedRoute>
    ),
  },
  {
    path: "/variantdetails/:variantId",
    element: (
      <AuthenticatedRoute>
        <VariantDetails />
      </AuthenticatedRoute>
    ),
  },
  {
    path: "/variantconsensus/:variantId",
    element: (
      <AuthenticatedRoute>
        <VariantConsensus />
      </AuthenticatedRoute>
    ),
  },
  {
    path: "/variantannotationdata",
    element: (
      <AuthenticatedRoute>
        <VariantAnnotationData />
      </AuthenticatedRoute>
    ),
  },
  {
    path: "/addinterpretation",
    element: (
      <AuthenticatedRoute>
        <AddInterpretation />
      </AuthenticatedRoute>
    ),
  },
  {
    path: "/userdashboard",
    element: (
      <AuthenticatedRoute>
        <UserDashboard />
      </AuthenticatedRoute>
    ),
  },
  {
    path: "/workflowruns",
    element: (
      <AuthenticatedRoute>
        <WorkflowRuns />
      </AuthenticatedRoute>
    ),
  },
  {
    path: "/programdashboard",
    element: (
      <AuthenticatedRoute>
        <ProgramDashboard />
      </AuthenticatedRoute>
    ),
  },
   {
    path: "/usermanagement",
    element: (
      <AuthenticatedRoute>
        <UserManagement />
      </AuthenticatedRoute>
    ),
  },
  {
    path: "/programsettings",
    element: (
      <AuthenticatedRoute>
        <ProgramSettings />
      </AuthenticatedRoute>
    ),
  },
  {
    path: "/variantdashboard/:variantId",
    element: (
      <AuthenticatedRoute>
        <VariantDashboard />
      </AuthenticatedRoute>
    ),
  },
  {
    path: "/help",
    element: (
      <AuthenticatedRoute>
        <Help />
      </AuthenticatedRoute>
    ),
  },
  { path: "/login", element: <LoginRedirect /> },
  { path: "/oauth-callback", element: <OAuthCallback /> },
  { path: "/error", element: <Error /> },
  { path: "/landing", element: <Landing /> },
  { path: "*", element: <Navigate to="/home" replace /> },
]);

const RouterComponent = () => <RouterProvider router={router} />;

export default RouterComponent;